
<template>
  <div class="indexnew">
    <div class="twobox">
      <div class="index_part_title">
        <span> <i class="el-icon-s-custom"></i>资金记录</span>
        <!-- @click="refresh" -->
        <i class="el-icon-refresh refresh"></i>
      </div>
      <div class="index_two_body">
        <div class="index_two_item">
          <div>
            <div>
              <!-- {{ data }} -->
              <p>{{ data.totalPlatformRevenue }}</p>
              <p>平台收益</p>
            </div>
            <img src="@/assets/img/index/two1.png" alt="" />
          </div>
          <p><span>今日</span>{{ data.todayPlatformRevenue }}</p>
          <p><span>昨日</span>{{ data.yesterdayPlatformRevenue }}</p>
        </div>
        <div class="index_two_item">
          <div>
            <div>
              <p>{{ data.totalEcpm }}</p>
              <p>总ECPM</p>
            </div>
            <img src="@/assets/img/index/two2.png" alt="" />
          </div>
          <p><span>今日</span>{{ data.todayEcpm }}</p>
          <p><span>昨日</span>{{ data.yesterdayEcpm }}</p>
        </div>
        <div class="index_two_item">
          <div>
            <div>
              <p>{{ data.totalPayouts }}</p>
              <p>总提现</p>
            </div>
            <img src="@/assets/img/index/two3.png" alt="" />
          </div>
          <p><span>今日</span>{{ data.todayPayouts }}</p>
          <p><span>昨日</span>{{ data.yesterdayPayouts }}</p>
        </div>
        <div class="index_two_item">
          <div>
            <div>
              <p>{{ data.totalUserCount }}</p>
              <p>总用户</p>
            </div>
            <img src="@/assets/img/index/two4.png" alt="" />
          </div>
          <p><span>今日</span>{{ data.todayUserCount }}</p>
          <p><span>昨日</span>{{ data.yesterdayUserCount }}</p>
        </div>
      </div>
    </div>
    <div class="twobox">
      <div class="index_part_title">
        <span> <i class="el-icon-s-custom"></i>资金记录</span>
        <!-- @click="refresh" -->
        <i class="el-icon-refresh refresh"></i>
      </div>
      <div class="index_two_body">
        <div class="index_two_item">
          <div>
            <div>
              <!-- {{ data }} -->
              <p>{{ data.totalUserNum }}</p>
              <p>用户收益</p>
            </div>
            <img src="@/assets/img/index/two1.png" alt="" />
          </div>
          <p><span>今日</span>{{ data.toDayUserNum }}</p>
          <p><span>昨日</span>{{ data.yesterDayUserNum }}</p>
        </div>
        <!-- <div class="index_two_item">
          <div>
            <div>
              <p>{{ data.totalUserAward }}</p>
              <p>代理佣金</p>
            </div>
            <img src="@/assets/img/index/three3.png" alt="" />
          </div>
          <p><span>今日</span>{{ data.toDayUserAward }}</p>
          <p><span>昨日</span>{{ data.yesterDayUserAward }}</p>
        </div> -->
        <div class="index_two_item">
          <div>
            <div>
              <!-- {{ data }} -->
              <p>{{ data.toDayDynamicUserNum }}</p>
              <p>今日日活</p>
            </div>
            <img src="@/assets/img/index/three1.png" alt="" />
          </div>
          <p><span>昨日</span>{{ data.yesterDayDynamicUserNum }}</p>
          <p><span>本月</span>{{ data.monthlyDynamicUserNum }}</p>
        </div>
      </div>
    </div>
    <div class="twobox">
      <div class="index_part_title">
        <span>
          <i class="el-icon-s-custom"></i>数据图
          <!-- <el-date-picker
            v-model="dateValue"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            size="mini"
            style="margin-left: 10px"
            @change="dateChange"
          >
          </el-date-picker
        > -->
        </span>

        <i class="el-icon-refresh refresh"></i>
      </div>
      <div class="index_two_body">
        <div
          class="echarts_box"
          ref="echarts_accessad_ref"
          style="width: 100%; height: 400px"
        ></div>
      </div>
    </div>
    <div class="twobox">
      <div class="index_part_title">
        <span> <i class="el-icon-s-custom"></i>数据图</span>

        <i class="el-icon-refresh refresh"></i>
      </div>
      <div class="index_two_body">
        <div
          class="echarts_box"
          ref="echarts_accessad_count_ref"
          style="width: 50%; height: 400px"
        ></div>
        <div
          class="echarts_box"
          ref="echarts_app_ref"
          style="width: 50%; height: 400px"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
let accessadOption = {
  title: {
    text: "ECPM",
  },
  tooltip: {
    trigger: "axis",
  },
  legend: {
    data: [],
  },
  grid: {
    left: "3%",
    right: "4%",
    bottom: "3%",
    containLabel: true,
  },
  toolbox: {
    feature: {
      saveAsImage: {},
    },
  },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: [],
    // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  },
  yAxis: {
    type: "value",
  },
  series: [],
};
let accessadCountOption = {
  title: {
    text: "广告数",
  },
  tooltip: {
    trigger: "axis",
  },
  legend: {
    data: [],
  },
  grid: {
    left: "3%",
    right: "4%",
    bottom: "3%",
    containLabel: true,
  },
  toolbox: {
    feature: {
      saveAsImage: {},
    },
  },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: [],
    // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  },
  yAxis: {
    type: "value",
  },
  series: [],
};
let appOption = {
  title: {
    text: "平台收益",
  },
  tooltip: {
    trigger: "axis",
  },
  legend: {
    data: [],
  },
  grid: {
    left: "3%",
    right: "4%",
    bottom: "3%",
    containLabel: true,
  },
  toolbox: {
    feature: {
      saveAsImage: {},
    },
  },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: [],
    // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  },
  yAxis: {
    type: "value",
  },
  series: [],
};
export default {
  data() {
    return {
      data: {},
      accessadEcahrt: null,
      dateValue: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [date, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      queryForm: {
        start_time: "",
        end_time: "",
      },
    };
  },

  methods: {
    dateChange(e) {
      let [start, end] = e;
      start = new Date(start).getTime();
      end = new Date(end).getTime();
      this.queryForm.start_time = start;
      this.queryForm.end_time = end;
      this.getEchartsData();
    },
    async getData() {
      let data = await this.$api.getData.getAllData();
      this.data = data.data.data;
    },
    async getEchartsData() {
      const loading = this.$loading({
        lock: true,
        text: "加载中....",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let { data } = await this.$api.getData.getEchartsData(this.queryForm);
      loading.close();
      accessadOption.series = data.accessadData.predefinedTags.map(
        (item, index) => {
          return {
            name: item,
            type: "line",
            smooth: true,
            data: data.accessadData.seriesData[index],
          };
        }
      );
      accessadOption.xAxis.data = data.accessadData.dates;
      accessadOption.legend.data = data.accessadData.predefinedTags;

      accessadCountOption.series = data.accessadConut.predefinedTags.map(
        (item, index) => {
          return {
            name: item,
            type: "line",
            smooth: true,
            data: data.accessadConut.seriesData[index],
          };
        }
      );
      accessadCountOption.xAxis.data = data.accessadConut.dates;
      accessadCountOption.legend.data = data.accessadConut.predefinedTags;

      appOption.series = data.appData.predefinedTags.map((item, index) => {
        return {
          name: item,
          type: "line",
          smooth: true,
          data: data.appData.seriesData[index],
        };
      });
      appOption.xAxis.data = data.appData.dates;
      appOption.legend.data = data.appData.predefinedTags;

      this.accessadEcahrt.setOption(accessadOption);
      this.accessadCountEcahrt.setOption(accessadCountOption);
      this.appEcahrt.setOption(appOption);
    },
  },
  created() {
    this.getData();
  },
  components: {},
  mounted() {
    this.accessadEcahrt = echarts.init(this.$refs.echarts_accessad_ref);
    this.appEcahrt = echarts.init(this.$refs.echarts_app_ref);
    this.accessadCountEcahrt = echarts.init(
      this.$refs.echarts_accessad_count_ref
    );
    this.getEchartsData();
  },
};
</script>
<style lang="less" scoped>
.twobox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 5px 20px #e4e4e4;
  border-radius: 5px;
  overflow: auto;
}

.index_two_body {
  width: 100%;
  padding: 15px;
  background-color: #ffffff;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  .index_two_item:not(:last-child) {
    margin-right: 15px;
  }
  .index_two_item {
    flex: 1;
    height: 170px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    background-color: #fbfbfb;
    padding: 0 15px;
    > div {
      width: 100%;
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #e8eaec;
      > img {
        width: 45px;
      }
      > div {
        display: flex;
        flex-flow: column;
        justify-content: flex-start;
        align-items: flex-start;
        > p:nth-of-type(1) {
          font-size: 20px;
          font-weight: 400;
          color: #515a6e;
          line-height: 50px;
        }
        > p:nth-of-type(2) {
          font-size: 15px;
          color: #212121;
        }
      }
    }
    > p {
      width: 100%;
      height: 40px;

      font-size: 16px;
      color: #8c8c8c;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      > span {
        font-size: 15px;
        margin-right: auto;
      }
    }
  }
}
.index_part_title {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  padding: 0 15px;
  border-bottom: 1px solid #e8eaec;
  margin-top: 12px;
}

.index_part_title span {
  font-size: 16px;
  margin-right: auto;
  font-weight: bold;
}
.index_part_title i {
  color: #1890ff;
  background-color: #e6f7ff;
  border-radius: 50%;
  padding: 4px;
  font-size: 16px;
  margin-right: 5px;
}

// .indexnew {
//   width: 100%;
//   height: 100%;
//   background-color: #f5f7f9;
//   overflow: auto;
//   padding: 20px 20px 20px 20px;
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: space-between;
//   color: #111;
// }
</style>
